export default __webpack_public_path__ + "static/media/historico.d21e6d00.svg";